import { usd } from '../../lib/format';
import { SELLER_COMMISSION_BPS, type SellerEarningsEstimate } from '../../lib/pricing';

/** Why there is no estimate, in one sentence; null when the price wins. */
export const estimateProblem = (estimate: SellerEarningsEstimate): string | null => {
  switch (estimate.kind) {
    case 'wins':
      return null;
    case 'loses':
      return `At this price you would not go first on any request: AnyAPI charges ${usd(estimate.fromUsdPer1k)} per 1,000 requests and goes first on a tie.`;
    case 'some-requests':
      return `At this price you would go first only on some requests, depending on how many results each asks for: AnyAPI charges from ${usd(estimate.floorUsdPer1k)} to ${usd(estimate.fromUsdPer1k)} per 1,000 requests. List below ${usd(estimate.floorUsdPer1k)} to win every request.`;
    case 'above-cap':
      return `The most you can list this API at is ${usd(estimate.priceCapUsdPer1k)} per 1,000 requests.`;
    case 'per-record':
      return 'This API is priced per record, and we only count requests, so it cannot be estimated yet.';
    case 'invalid':
      return 'Enter a price above $0 and an uptime from 0 to 100%.';
  }
};

/** The share of what customers pay that a seller keeps, in percent. */
export const SELLER_SHARE_PCT = 100 - SELLER_COMMISSION_BPS / 100;

/** The assumption every figure rests on. */
export const ASSUMPTION = `Assumes you win every request you answer: you go first on every request when your price is below the least AnyAPI charges, and you keep ${SELLER_SHARE_PCT}% of what customers pay.`;
